import { render, staticRenderFns } from "./SectionItemArchive.vue?vue&type=template&id=239f0456&lang=pug&"
import script from "./SectionItemArchive.vue?vue&type=script&lang=js&"
export * from "./SectionItemArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports